export enum RectangleAnchorPointName {
    LEFT_TOP = 'leftTop',
    LEFT_BOTTOM = 'leftBottom',
    RIGHT_BOTTOM = 'rightBottom',
    RIGHT_TOP = 'rightTop',
}
export type CornerPoint = {
    left: number;
    top: number;
    type: RectangleAnchorPointName;
};

export enum EDeformationEvent {
    CONFIRM = 'deformation-img:confirm',
    CANCEL = 'deformation-img:cancel',
    INNER_CONFIRM = 'deformation-img:inner-confirm',
    /** 会话已结束，包括确认保存、主动取消和编辑器重新初始化 */
    CLOSED = 'deformation-img:closed',
    /** GL 初始化或预览导出失败；回调接收错误及是否需要结束会话 */
    ERROR = 'deformation-img:error',
}

/** 变形结果相对原图片左上角的局部偏移，单位为设计稿像素 */
export interface IDeformationOffset {
    left: number;
    top: number;
}
